<template>
  <div class="breadcrumb-component">
    <div class="breadcrumb-wrapper">
      <span v-for="(element, index) in route" class="breadcrumb-element" :key="index">
        <span v-if="index > 0" class="breadcrumb-separator">{{separator}}</span>
        <span v-if="element.url && element.url.length > 0" class="breadcrumb link" @click="redirect(element)">{{ $t(element.name) }}</span>
        <span v-else class="breadcrumb">{{ $t(element.name) }}</span>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BreadcrumbComponent',
  props: {
    mode: {
      type: String,
      deafult: 'auto'
    },
    route: [],
    separator: {
      type: String,
      default: '/'
    },
  },
  methods: {
    redirect(element) {
      if(element.absolute) {
        window.location.href = element.url;
      } else {
        this.$router.push({path: element.url})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-component {
  width: 100%;
  .breadcrumb-wrapper {
    height: 48px;
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    display: flex;
  }
  font-size: 12px;
  line-height: 48px;
  text-decoration: none !important;
  color: #67696D;
  .breadcrumb {
    padding-right: 8px;
    color: #67696D;
    &.link {
      cursor: pointer;
      color: $ds-primary;
    }
  }
  .breadcrumb-separator {
    padding-right: 8px;
    font-size: 20px;
    color: #67696D !important;
  }
  .breadcrumb-element {
    display: flex;
    align-items: center;
  }
}
</style>